import { FC, PropsWithChildren, useEffect } from 'react';
import { useGetUser } from '@/queries/user';

export const MicrosoftClarityContainer: FC<PropsWithChildren> = ({
  children,
}) => {
  const { data } = useGetUser();

  useEffect(() => {
    if (typeof window !== 'undefined' && window.clarity && data?.hashedPk) {
      window.clarity('identify', data.hashedPk);
    }
  }, [data?.hashedPk]);

  return children;
};
